import React, {useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { AppBar, Toolbar, Button, Box, Menu,
//     MenuItem, IconButton } from '@mui/material';

import { AppBar, Toolbar, Button, IconButton, Box, IconButton as MuiIconButton,
        Menu, MenuItem, Avatar, Badge, Typography, Drawer, List, ListItem, ListItemText} from '@mui/material';
import { Link } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import logo from '../assets/images/logos/Logo-01.png';
import userIcon from '../assets/images/icons/user-icon.png';

import { Menu as MenuIcon, AccountCircle, Language as LanguageIcon } from '@mui/icons-material';


// export const isAuthenticated = () => {
//     return !!localStorage.getItem('authToken'); // Or your preferred method of checking auth status
// };

export const isAuthenticated = () => {
    // Check if token exists in localStorage or sessionStorage based on the user's choice (rememberMe)
    const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
    const tokenExpiration = localStorage.getItem('tokenExpiration') || sessionStorage.getItem('tokenExpiration');
    
    // Check if the token exists and is not expired
    if (token && tokenExpiration) {
      const currentTime = new Date();
      const expirationTime = new Date(tokenExpiration);
      return currentTime < expirationTime; // Return true if token is still valid
    }
    
    return false; // Return false if no token or if token is expired
};
  
  
  export const getRole = () => {
    // Retrieve the user role from localStorage or sessionStorage depending on how it was stored
    return localStorage.getItem('userRole') || sessionStorage.getItem('userRole');
  };
  

const Navbar = () => {

    const role = getRole();
    //console.log(isAuthenticated(), role);

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const navigate = useNavigate();

    // Toggle mobile drawer
    const toggleMobileMenu = (open) => () => {
        setMobileMenuOpen(open);
    };

    // Mock user data
    const user = {
        isAuthenticated: isAuthenticated(), 
        profilePicture: null,  // URL for profile picture, null if no picture
        role: role 
    };

    //console.log(user);

    // Mock language state
    const [language, setLanguage] = useState('EN');

    const changeLanguage = (lang) => {
        setLanguage(lang);
        handleLanguageMenuClose();
    };

    const handleNotificationsMenuOpen = (event) => setNotificationsAnchorEl(event.currentTarget);
    const handleNotificationsMenuClose = () => setNotificationsAnchorEl(null);
    const handleProfileMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleProfileMenuClose = () => setAnchorEl(null);
    const handleLanguageMenuOpen = (event) => setLanguageAnchorEl(event.currentTarget);
    const handleLanguageMenuClose = () => setLanguageAnchorEl(null);


    const handleViewProfile = () => {
        navigate('/profile');
    };

    const handleLogout = () => {
        // Clear token and user data from local storage or session storage
         // Clear token and user data from both storages
        localStorage.removeItem('authToken');
        localStorage.removeItem('userRole');
        localStorage.removeItem('tokenExpiration');

        sessionStorage.removeItem('authToken');
        sessionStorage.removeItem('userRole');
        sessionStorage.removeItem('tokenExpiration');

        // Redirect to the login page
        navigate('/'); // Ensure React Router handles navigation
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const [languageAnchorEl, setLanguageAnchorEl] = useState(null);
    const [notificationsAnchorEl, setNotificationsAnchorEl] = useState(null);

    return(
        <AppBar position="static">
            <Toolbar sx={{ backgroundColor: '#fff', margin: 0, justifyContent: 'space-between' }}>
                <Link to="/" style={{ textDecoration: "none" }}>
                    <Box 
                        component="img" 
                        src={logo} 
                        alt="Logo"
                        sx={{ 
                            height: { xs: 25, xxl: 39 }, 
                            mr: 2, 
                            ml: { xs: 0, xxl: 5 }
                        }} 
                    />
                </Link>

                {/* Hamburger Menu Icon */}
                { (!isAuthenticated() || (isAuthenticated() && role === 'Member')) && (
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="menu"
                        onClick={toggleMobileMenu(true)}
                        sx={{ 
                            display: { xs: 'block', xxl: 'none' },
                            position: "absolute",
                            right: 16
                        }} 
                    >
                        <MenuIcon />
                    </IconButton>
                )}

                {/* Drawer for Mobile Menu */}
                <Drawer 
                    role="presentation"
                    open={mobileMenuOpen} 
                    onClose={toggleMobileMenu(false)}
                    PaperProps={{
                        sx: { 
                            width: "100%", 
                            height: "auto", 
                            borderRadius: 0, 
                            margin: 0,
                            marginTop: "50px"
                        }
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#fff",
                            width: "100%",
                            minHeight: "auto",
                            padding: 2,
                        }}
                        role="presentation"
                        onClick={toggleMobileMenu(false)}
                        onKeyDown={toggleMobileMenu(false)}
                    >
                        <List>
                            <ListItem button component={Link} to="/">
                                <ListItemText primary="Our Club" 
                                    primaryTypographyProps={{
                                        sx: {
                                            padding: 0.5,
                                            color: "#000",
                                            textTransform: "none",
                                            fontFamily: "Instrument Sans, sans-serif",
                                            fontWeight: 500, 
                                            fontSize: "18px", 
                                            lineHeight: "28px",
                                            letterSpacing: "normal", 
                                            textAlign: "center"
                                        }
                                    }}
                                />
                            </ListItem>
                            <ListItem button component={Link} to="/ourculture">
                                <ListItemText primary="Our Culture" 
                                    primaryTypographyProps={{
                                        sx: {
                                            padding: 0.5,
                                            color: "#000",
                                            textTransform: "none",
                                            fontFamily: "Instrument Sans, sans-serif",
                                            fontWeight: 500, 
                                            fontSize: "18px", 
                                            lineHeight: "28px",
                                            letterSpacing: "normal", 
                                            textAlign: "center"
                                        }
                                    }}
                                />
                            </ListItem>
                            { !isAuthenticated() ? (
                                <ListItem button component={Link} to="/login">
                                    <ListItemText primary="Login"     
                                        primaryTypographyProps={{
                                            sx: {
                                                padding: 0.5,
                                                color: "#000",
                                                textTransform: "none",
                                                fontFamily: "Instrument Sans, sans-serif",
                                                fontWeight: 500, 
                                                fontSize: "18px", 
                                                lineHeight: "28px",
                                                letterSpacing: "normal", 
                                                textAlign: "center"
                                            }
                                        }}
                                    />
                                </ListItem>
                            ) : (
                                <>
                                    <ListItem button component={Link} to="/mycourses">
                                        <ListItemText primary="My Dashboard" 
                                            primaryTypographyProps={{
                                                sx: {
                                                    padding: 0.5,
                                                    color: "#000",
                                                    textTransform: "none",
                                                    fontFamily: "Instrument Sans, sans-serif",
                                                    fontWeight: 500, 
                                                    fontSize: "18px", 
                                                    lineHeight: "28px",
                                                    letterSpacing: "normal", 
                                                    textAlign: "center"
                                                }
                                            }}
                                        />
                                    </ListItem>
                                    <ListItem button onClick={handleLogout}>
                                        <ListItemText primary="Logout" 
                                            primaryTypographyProps={{
                                                sx: {
                                                    padding: 0.5,
                                                    color: "#000",
                                                    textTransform: "none",
                                                    fontFamily: "Instrument Sans, sans-serif",
                                                    fontWeight: 500, 
                                                    fontSize: "18px", 
                                                    lineHeight: "28px",
                                                    letterSpacing: "normal", 
                                                    textAlign: "center"
                                                }
                                            }}
                                        />
                                    </ListItem>
                                </>
                            )}
                        </List>
                    </Box>
                </Drawer>

                <Box 
                    sx={{ 
                        display: { xs: 'none', xxl: 'flex' },
                        gap: 1, 
                        marginRight: { xs: 0, xxl: 5 } 
                    }} 
                >  
                    {!isAuthenticated() && (
                        <>
                            <Button color="inherit" component={Link} to="/">
                                <Typography variant="h4" 
                                    sx={{
                                        color: "#000",
                                        textTransform: "none",
                                        fontFamily: "Instrument Sans, sans-serif",
                                        fontWeight: 500, 
                                        fontSize: "20px", 
                                        lineHeight: "28px",
                                        letterSpacing: "normal", 
                                        display: { xs: 'none', sm: 'flex' },
                                      }}
                                >
                                    Our Club
                                </Typography>
                            </Button>
                            <Button color="inherit" component={Link} to="/ourculture">
                                <Typography variant="outlined" 
                                    sx={{
                                        color: "#000",
                                        textTransform: "none",
                                        fontFamily: "Instrument Sans, sans-serif",
                                        fontWeight: 500, 
                                        fontSize: "20px", 
                                        lineHeight: "28px",
                                        letterSpacing: "normal", 
                                        display: { xs: 'none', sm: 'flex' },
                                    }}
                                >
                                    Our Culture
                                </Typography>
                            </Button>
                            {/*<Button color="inherit" component={Link} to="/">
                                <Typography variant="outlined" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                    Blog
                                </Typography>
                            </Button> */}
                            <Button color="inherit" component={Link} to="/login" sx={{ display: { xs: 'none', xxl: 'flex' }, padding: 0}}>
                                <Box
                                    component="img"
                                    src={userIcon}
                                    alt="Login"
                                    sx={{
                                        width: "37.5px", 
                                        height: "37.5px", 
                                    }}
                                />
                            </Button>
                        </>
                    )}

                    {isAuthenticated() && role === 'Member' && (
                        <>
                        <Button color="inherit" component={Link} to="/">
                            <Typography variant="h4" 
                                sx={{
                                    color: "#000",
                                    textTransform: "none",
                                    fontFamily: "Instrument Sans, sans-serif",
                                    fontWeight: 500, 
                                    fontSize: "20px", 
                                    lineHeight: "28px",
                                    letterSpacing: "normal", 
                                    display: { xs: 'none', sm: 'flex' },
                                  }}
                            >
                                Our Club
                            </Typography>
                        </Button>
                        <Button color="inherit" component={Link} to="/ourculture">
                            <Typography variant="outlined" 
                                sx={{
                                    color: "#000",
                                    textTransform: "none",
                                    fontFamily: "Instrument Sans, sans-serif",
                                    fontWeight: 500, 
                                    fontSize: "20px", 
                                    lineHeight: "28px",
                                    letterSpacing: "normal", 
                                    display: { xs: 'none', sm: 'flex' },
                                }}
                            >
                                Our Culture
                            </Typography>
                        </Button>
                        {/*
                        <Button color="inherit" component={Link} to="/">
                            <Typography variant="outlined" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                Blog
                            </Typography>
                        </Button> */}
                        <Button color="inherit" component={Link} to="/mycourses">
                            <Typography variant="outlined" 
                                sx={{
                                    color: "#000",
                                    textTransform: "none",
                                    fontFamily: "Instrument Sans, sans-serif",
                                    fontWeight: 500, 
                                    fontSize: "20px", 
                                    lineHeight: "28px",
                                    letterSpacing: "normal", 
                                    display: { xs: 'none', sm: 'flex' },
                                }}
                            >
                                My Dashboard
                            </Typography>
                        </Button>

                        {/* User Profile Picture */}
                        <IconButton color="inherit" onClick={handleProfileMenuOpen} sx={{ display: { xs: 'none', xxl: 'flex' }, alignItems: 'center', padding: '0' }}>
                            {user.profilePicture ? (
                            <Avatar src={user.profilePicture} style={{ fontSize: '0.9rem'}} />
                            ) : (
                                <Box
                                    component="img"
                                    src={userIcon}
                                    alt="Login"
                                    sx={{
                                        width: "37.5px", 
                                        height: "37.5px", 
                                    }}
                                />
                            )} 
                            <ArrowDropDownIcon /> 
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleProfileMenuClose}
                        >
                            {/* <MenuItem onClick={handleViewProfile}>Profile</MenuItem> */}
                            <MenuItem onClick={handleLogout}>Logout</MenuItem>
                        </Menu>
                        </>
                    )}
                    {/* <Button color="inherit" component={Link} to="/members">Members</Button> */}
                    {/* <Button color="inherit" component={Link} to="/admin">Admin Dashboard</Button> */}
                    
                    {isAuthenticated() && role === 'Manager' && (
                        <>
                        {/* Members */}
                        <Button color="inherit" component={Link} to="/members">
                            <Typography variant="outlined" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                Members
                            </Typography>
                        </Button>

                        {/* Authors */}
                        <Button color="inherit" component={Link} to="/authors">
                            <Typography variant="outlined" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                Authors
                            </Typography>
                        </Button>

                        {/* Memberships */}
                        <Button color="inherit" component={Link} to="/memberships">
                            <Typography variant="outlined" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                Memberships
                            </Typography>
                        </Button>

                        {/* Courses */}
                        <Button color="inherit" component={Link} to="/courses">
                            <Typography variant="outlined" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                Courses
                            </Typography>
                        </Button>

                        {/* Lessons */}
                        <Button color="inherit" component={Link} to="/lessons">
                            <Typography variant="outlined" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                Lessons
                            </Typography>
                        </Button>

                        {/* SubLessons */}
                        {/* <Button color="inherit" component={Link} to="/sublessons">
                            <Typography variant="outlined" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                Sublessons
                            </Typography>
                        </Button> */}

                        {/* Marketing */}
                        <Button color="inherit" component={Link} to="/marketing">
                            <Typography variant="outlined" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                Marketing
                            </Typography>
                        </Button>

                        {/* Notification Center */}
                        <IconButton color="inherit" onClick={handleNotificationsMenuOpen} >
                            {/* style="margin-right: 10px; fontSize: 0.8rem"> */}
                            <Badge badgeContent={1} color="error">
                            <NotificationsIcon />
                            </Badge>
                        </IconButton>
                        <Menu
                            anchorEl={notificationsAnchorEl}
                            open={Boolean(notificationsAnchorEl)}
                            onClose={handleNotificationsMenuClose}
                        >
                            <MenuItem onClick={handleNotificationsMenuClose}>No new notifications</MenuItem>
                            {/* You can loop through notifications here */}
                        </Menu>

                        {/* User Profile Picture */}
                        <IconButton color="inherit" onClick={handleProfileMenuOpen} sx={{ display: 'flex', alignItems: 'center', padding: '0' }}>
                            {user.profilePicture ? (
                            <Avatar src={user.profilePicture} style={{ fontSize: '0.9rem'}} />
                            ) : (
                                <AccountCircle style={{ fontSize: '0.9rem'}} />
                            )} 
                            <ArrowDropDownIcon /> 
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleProfileMenuClose}
                        >
                            <MenuItem onClick={handleViewProfile}>Profile</MenuItem>
                            <MenuItem onClick={handleLogout}>Logout</MenuItem>
                        </Menu>

                        {/* Language Selector */}
                        <IconButton color="inherit" onClick={handleLanguageMenuOpen} sx={{ display: 'flex', alignItems: 'center', padding: '0' }}>
                            <Typography variant="outlined" sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>{language}</Typography>
                            <ArrowDropDownIcon /> 
                        </IconButton>
                        <Menu
                            anchorEl={languageAnchorEl}
                            open={Boolean(languageAnchorEl)}
                            onClose={handleLanguageMenuClose}
                        >
                            <MenuItem onClick={() => changeLanguage('EN')}>EN</MenuItem>
                            <MenuItem onClick={() => changeLanguage('RO')}>RO</MenuItem>
                        </Menu>
                        
                      </>
                    )}
                    {/* <Button color="inherit" component={Link} to="/register">Register</Button> */}
               
                </Box>
            </Toolbar>
        </AppBar>
    )
};

export default Navbar;